import React from 'react';
import { get } from 'lodash';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import TradingViewUrl from '../../../common/TradingViewUrl';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import {
  changeIdHover,
  changeTableIndexSortState,
  notifyResizeColumnTable,
  REDUCER_NAME,
  setSortedIds,
  toggleConfirmPopupDelete,
  updateBidAsk,
} from '../reducer';
import { connect } from 'react-redux';
import Table from '../../../common/table/Table';
import Const from './Const';
import { includes, omit } from 'lodash';
import { I18n } from 'react-redux-i18n';
import {
  getColorPrice,
  getColorRedGreen,
  getColorRedWhite,
  getColorRefPrice,
} from '../../../helpers/Color';
import {
  formatPercent,
  formatPrice,
  formatTextFloat,
  formatValue,
  formatVolume,
} from '../../../helpers/Text';
import {
  formatComGroupCode,
  getDataFollowKeyByDot,
  getRanking,
  syncComponentSelector,
} from './../../../helpers/Common';
import HeadTrend from './HeadTrend';
import CellTrend from './CellTrend';
import CellHover from './CellHover';
import DayRange from './DayRange';
import YearRange from './OneYearRange';
import PerformanceChartWrap from './PerformanceChartWrap';
import TextBlink from '../../../common/table/TextBlink';
import './table.scss';
import { compose } from 'redux';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import BidAsk from './BidAsk';

const getDataFromRedux = state => state[REDUCER_NAME].listSummaryTableByTicker;

class TableIndex extends React.Component {
  componentDidMount() {
    this.handleSubscribeBidAsk();
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
  }

  componentDidUpdate(prevProps) {
    const { listHideColumnIndex } = this.props;
    if (listHideColumnIndex === prevProps.listHideColumnIndex) {
      return;
    }
    if (
      listHideColumnIndex.includes(Const.listHideColumnIndex.BEST_1_BID) &&
      listHideColumnIndex.includes(Const.listHideColumnIndex.BEST_1_OFFER)
    ) {
      MessageHub.subscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
    }
  }

  handleSubscribeBidAsk = () => {
    const { listHideColumnIndex } = this.props;
    if (
      listHideColumnIndex.includes(Const.listHideColumnIndex.BEST_1_BID) &&
      listHideColumnIndex.includes(Const.listHideColumnIndex.BEST_1_OFFER)
    ) {
      return;
    }
    MessageHub.subscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
  };

  onReceiveBidAsk = data => {
    const { ids, updateBidAsk } = this.props;
    const bidAskData = {};
    data.forEach(item => {
      const isInId = ids.some(id => id === item.organCode);
      if (isInId) {
        if (!bidAskData[item.organCode]) {
          bidAskData[item.organCode] = {};
        }
        bidAskData[item.organCode].bidAsk = item;
      }
    });
    if (Object.keys(bidAskData).length) {
      updateBidAsk(bidAskData);
    }
  };

  handleDelete = (isShow, organCode) => () => {
    const { toggleConfirmPopupDelete } = this.props;

    toggleConfirmPopupDelete(isShow, organCode);
  };

  getSchema = () => {
    return Object.keys(omit(Const.index, Const.listIgnoreColumnIndex)).map(
      (item2, index) => {
        const key = Const.index[item2];
        const title = `watchListSummary.listTitleIndexTable.${item2}`;
        const result = {
          key,
          title,
        };

        if (index === 0) {
          return {
            thStyle: {
              width: '10%',
            },
            isString: true,
            ...result,
            render: (text, item) => {
              return (
                <CellHover
                  organCode={item.organCode}
                  isShowDeleteIcon={this.props.isShowDeleteIcon}
                  handleDelete={this.handleDelete(
                    true,
                    getDataFollowKeyByDot(item, Const.index.ORGAN_CODE),
                  )}
                >
                  <div className="pl-10">
                    <TradingViewUrl code={item.organCode} />
                    &nbsp;
                    {text}
                  </div>
                </CellHover>
              );
            },
          };
        }

        if (key === Const.index.REFERENCE_PRICE) {
          return {
            ...result,
            render: (text, item) => (
              <TextBlink
                item={item}
                tradingDate={Const.index.TRADING_DATE}
                className={getColorRefPrice(
                  formatTextFloat(formatPrice(text)),
                  'text',
                )}
              >
                {formatTextFloat(formatPrice(text), 2, true)}
              </TextBlink>
            ),
          };
        }

        if (includes([Const.index.BEST_1_BID, Const.index.BEST_1_OFFER], key)) {
          return {
            ...result,
            render: (text, item) => {
              const { summaryBidAskRealtimeData } = this.props;
              const realtimeData =
                summaryBidAskRealtimeData[item.organCode] || {};
              const bidAsk = get(realtimeData, key) || text;
              return <BidAsk text={bidAsk} item={item} itemKey={key} />;
            },
          };
        }

        if (
          includes(
            [
              Const.index.AVERAGE_PRICE,
              Const.index.CEILING_PRICE,
              Const.index.HIGHEST_PRICE,
              Const.index.FLOOR_PRICE,
              Const.index.DEAL_PRICE,
              Const.index.LOWEST_PRICE,
              Const.index.OPEN_PRICE,
            ],
            key,
          )
        ) {
          return {
            ...result,
            render: (text, item) => {
              const className = getColorPrice(
                getDataFollowKeyByDot(item, key),
                getDataFollowKeyByDot(item, Const.index.REFERENCE_PRICE),
                getDataFollowKeyByDot(item, Const.index.CEILING_PRICE),
                getDataFollowKeyByDot(item, Const.index.FLOOR_PRICE),
                'text',
              );
              return (
                <TextBlink
                  item={item}
                  tradingDate={Const.index.TRADING_DATE}
                  className={className}
                >
                  {formatTextFloat(formatPrice(text), 2, true)}
                </TextBlink>
              );
            },
          };
        }

        if (includes([Const.index.MATCH_PRICE], key)) {
          return {
            ...result,
            render: (text, item) => {
              const className = getColorPrice(
                getDataFollowKeyByDot(item, key),
                getDataFollowKeyByDot(item, Const.index.REFERENCE_PRICE),
                getDataFollowKeyByDot(item, Const.index.CEILING_PRICE),
                getDataFollowKeyByDot(item, Const.index.FLOOR_PRICE),
                'text',
              );
              return (
                <TextBlink
                  item={item}
                  tradingDate={Const.index.TRADING_DATE}
                  className={className}
                >
                  {formatTextFloat(formatPrice(text))}
                </TextBlink>
              );
            },
          };
        }

        if (includes([Const.index.PRICE_CHANGE, Const.index.D_CHANGE], key)) {
          return {
            ...result,
            render: (text, item) => {
              const className = getColorPrice(
                getDataFollowKeyByDot(item, Const.index.MATCH_PRICE),
                getDataFollowKeyByDot(item, Const.index.REFERENCE_PRICE),
                getDataFollowKeyByDot(item, Const.index.CEILING_PRICE),
                getDataFollowKeyByDot(item, Const.index.FLOOR_PRICE),
                'text',
              );
              if (includes([Const.index.D_CHANGE], key)) {
                const val = formatTextFloat(text * 100);
                return (
                  <TextBlink
                    item={item}
                    tradingDate={Const.index.TRADING_DATE}
                    className={className}
                  >
                    {val === '--' ? val : val + ' %'}
                  </TextBlink>
                );
              }
              return (
                <TextBlink
                  item={item}
                  tradingDate={Const.index.TRADING_DATE}
                  className={className}
                >
                  {formatTextFloat(formatPrice(text))}
                </TextBlink>
              );
            },
          };
        }

        if (key === Const.index.NET_FOREIGN_VOLUME_TOTAL) {
          return {
            ...result,
            thStyle: {
              width: '70px',
            },
            render: (text, item) => {
              let volume =
                getDataFollowKeyByDot(
                  item,
                  Const.index.FOREIGN_BUY_VOLUME_TOTAL,
                ) -
                getDataFollowKeyByDot(
                  item,
                  Const.index.FOREIGN_SELL_VOLUME_TOTAL,
                );
              if (
                getDataFollowKeyByDot(
                  item,
                  Const.index.FOREIGN_BUY_VOLUME_TOTAL,
                ) === '--' ||
                getDataFollowKeyByDot(
                  item,
                  Const.index.FOREIGN_SELL_VOLUME_TOTAL,
                ) === '--'
              ) {
                volume = '--';
              }

              const className = getColorRedWhite(volume, 'text');
              return (
                <TextBlink
                  item={item}
                  tradingDate={Const.index.TRADING_DATE}
                  className={className}
                >
                  {formatTextFloat(formatVolume(volume), 2, true)}
                </TextBlink>
              );
            },
            valueFromItem: item =>
              getDataFollowKeyByDot(
                item,
                Const.index.FOREIGN_BUY_VOLUME_TOTAL,
              ) -
              getDataFollowKeyByDot(
                item,
                Const.index.FOREIGN_SELL_VOLUME_TOTAL,
              ),
          };
        }

        if (
          includes(
            [
              Const.index.TOTAL_BUY_TRADE_VOLUME,
              Const.index.TOTAL_SELL_TRADE_VOLUME,
            ],
            key,
          )
        ) {
          return {
            ...result,
            render: (text, item) => {
              const isVnIndex =
                item.bidAsk && item.bidAsk.comGroupCode === 'VNINDEX';
              if (text - get(item, Const.index.TOTAL_MATCH_VOLUME) < 0) {
                return '--';
              }

              return (
                <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                  {isVnIndex
                    ? '--'
                    : formatTextFloat(
                        formatVolume(
                          text -
                            getDataFollowKeyByDot(
                              item,
                              Const.index.TOTAL_MATCH_VOLUME,
                            ),
                        ),
                        2,
                        true,
                      )}
                </TextBlink>
              );
            },
          };
        }

        if (
          includes(
            [
              Const.index.FOREIGN_SELL_VOLUME_MATCHED,
              Const.index.FOREIGN_BUY_VOLUME_MATCHED,
              Const.index.FOREIGN_BUY_VOLUME_TOTAL,
              Const.index.FOREIGN_SELL_VOLUME_TOTAL,
              Const.index.TOTAL_DEAL_VOLUME,
            ],
            key,
          )
        ) {
          return {
            ...result,
            render: (text, item) => (
              <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                {formatTextFloat(formatVolume(text), 2, true)}
              </TextBlink>
            ),
          };
        }

        if (
          includes(
            [
              Const.index.AVERAGE_MATCHED_VOLUME_2WEEK,
              Const.index.AVERAGE_MATCHED_VOLUME_1MONTH,
              Const.index.AVERAGE_MATCHED_VOLUME_3MONTH,
              Const.index.AVERAGE_MATCHED_VOLUME_1YEAR,
              Const.index.TOTAL_MATCH_VOLUME,
              Const.index.TOTAL_VOLUME,
              Const.index.MATCH_VOLUME,
              Const.index.FOREIGN_CURRENT_ROOM,
            ],
            key,
          )
        ) {
          return {
            ...result,
            render: (text, item) => (
              <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                {formatTextFloat(formatVolume(text))}
              </TextBlink>
            ),
          };
        }

        if (
          includes(
            [
              Const.index.FOREIGN_BUY_VALUE_TOTAL,
              Const.index.FOREIGN_SELL_VALUE_TOTAL,
              Const.index.TOTAL_DEAL_VALUE,
            ],
            key,
          )
        ) {
          return {
            ...result,
            render: (text, item) => (
              <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                {formatTextFloat(formatValue(text), 2, true)}
              </TextBlink>
            ),
          };
        }

        if (includes([Const.index.TOTAL_MATCH_VALUE], key)) {
          return {
            ...result,
            render: (text, item) => (
              <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                {formatTextFloat(formatValue(text), 2, true)}
              </TextBlink>
            ),
          };
        }

        if (includes([Const.index.MATCH_VALUE, Const.index.FREE_FLOAT], key)) {
          return {
            ...result,
            render: (text, item) => (
              <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                {formatTextFloat(formatValue(text))}
              </TextBlink>
            ),
          };
        }

        if (includes([Const.index.FOREIGN_NET_VALUE_TOTAL], key)) {
          const getForeignValue = item => {
            const foreignBuyValue = getDataFollowKeyByDot(
              item,
              Const.index.FOREIGN_BUY_VALUE_TOTAL,
            );
            const foreignSellValue = getDataFollowKeyByDot(
              item,
              Const.index.FOREIGN_SELL_VALUE_TOTAL,
            );

            if (!(foreignBuyValue === 0 && foreignSellValue === 0)) {
              return formatValue(foreignBuyValue - foreignSellValue);
            }

            return null;
          };

          return {
            ...result,
            valueFromItem: getForeignValue,
            render: (text, item) => {
              const value = getForeignValue(item);
              return (
                <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                  {value === null ? '--' : formatTextFloat(value)}
                </TextBlink>
              );
            },
          };
        }

        if (includes([Const.index.FREE_FLOAT_RATE], key)) {
          return {
            ...result,
            render: (text, item) => {
              return (
                <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                  {formatTextFloat(formatPercent(text))}
                </TextBlink>
              );
            },
          };
        }

        if (key === Const.index.RANKING) {
          return {
            key,
            title,
            thStyle: { width: '70px' },
            thTooltip: I18n.t('table.market.ranking'),
            render: (rank, item) => {
              const totalRank = getDataFollowKeyByDot(
                item,
                Const.index.TOTAL_RANK,
              );
              return (
                <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                  {getRanking(rank, totalRank)}
                </TextBlink>
              );
            },
          };
        }

        if (key === Const.index.CLOSE_PRICE) {
          return {
            key,
            disableSort: true,
            disableResize: true,
            isHtml: true,
            title: <HeadTrend>{title}</HeadTrend>,
            thTooltip: I18n.t('table.market.trend'),
            thStyle: { width: '50px', textAlign: 'center' },
            render: (text, item) => <CellTrend>{item}</CellTrend>,
          };
        }

        if (includes([Const.index.ORGAN_SHORT_NAME], key)) {
          return {
            ...result,
            isString: true,
            thStyle: { textAlign: 'left' },
            render: text => (
              <div style={{ paddingRight: 10, paddingLeft: 10 }}>
                <div className="text-left">{text}</div>
              </div>
            ),
          };
        }

        if (key === Const.index.DAY_RANGE) {
          return {
            disableSort: true,
            disableResize: true,
            thStyle: { width: '153px', textAlign: 'center' },
            ...result,
            render: (text, item) => {
              const lowestPrice = formatPrice(
                getDataFollowKeyByDot(item, Const.index.LOWEST_PRICE),
              );
              const highestPrice = formatPrice(
                getDataFollowKeyByDot(item, Const.index.HIGHEST_PRICE),
              );
              const matchPrice = formatPrice(
                getDataFollowKeyByDot(item, Const.index.MATCH_PRICE),
              );
              const referencePrice = formatPrice(
                getDataFollowKeyByDot(item, Const.index.REFERENCE_PRICE),
              );
              if (
                includes(
                  [lowestPrice, highestPrice, matchPrice, referencePrice],
                  '--',
                )
              ) {
                return;
              }
              return (
                <div style={{ padding: '0 8px', width: '150px' }}>
                  <DayRange
                    key={Const.index.DAY_RANGE}
                    lowestPrice={lowestPrice}
                    highestPrice={highestPrice}
                    matchPrice={matchPrice}
                    referencePrice={referencePrice}
                  />
                </div>
              );
            },
          };
        }

        if (key === Const.index._52W_RANGE) {
          return {
            disableSort: true,
            disableResize: true,
            thStyle: { width: '153px', textAlign: 'center' },
            ...result,
            render: (text, item) => {
              const lowestPrice = formatPrice(
                getDataFollowKeyByDot(item, Const.index.ONE_YEAR_LOW),
              );
              const highestPrice = formatPrice(
                getDataFollowKeyByDot(item, Const.index.ONE_YEAR_HIGH),
              );
              const matchPrice = formatPrice(
                getDataFollowKeyByDot(item, Const.index.MATCH_PRICE),
              );
              const referencePrice = formatPrice(
                getDataFollowKeyByDot(item, Const.index.REFERENCE_PRICE),
              );
              if (
                includes(
                  [lowestPrice, highestPrice, matchPrice, referencePrice],
                  '--',
                )
              ) {
                return;
              }
              return (
                <YearRange
                  key={Const.index._52W_RANGE}
                  lowestPrice={lowestPrice}
                  highestPrice={highestPrice}
                  matchPrice={matchPrice}
                  referencePrice={referencePrice}
                />
              );
            },
          };
        }

        if (key === Const.index.PERFORMANCE) {
          return {
            disableSort: true,
            disableResize: true,
            ...result,
            tdClassName: 'fix-width-chart',
            thStyle: { textAlign: 'center', width: '125px' },
            thTooltip: I18n.t('table.market.performance'),
            onResize: width => {},
            render: (text, item) => {
              let tickerKey = getDataFollowKeyByDot(
                item,
                Const.index.ORGAN_CODE,
              );
              return (
                <div style={{ paddingRight: 10, paddingLeft: 10 }}>
                  <div style={{ margin: '0 auto' }}>
                    <PerformanceChartWrap ticker={tickerKey} />
                  </div>
                </div>
              );
            },
          };
        }

        if (
          includes(
            [
              Const.index.PERCENT_PRICE_CHANGE_1WEEK,
              Const.index.PERCENT_PRICE_CHANGE_1MONTH,
              Const.index.PERCENT_PRICE_CHANGE_3MONTH,
              Const.index.PERCENT_PRICE_CHANGE_1YEAR,
            ],
            key,
          )
        ) {
          return {
            ...result,
            render: (text, item) => {
              const colorClass = getColorRedGreen(text);
              return (
                <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                  <div className={colorClass}>{formatPercent(text) + '%'}</div>
                </TextBlink>
              );
            },
          };
        }

        if (key === Const.index.PUT_THROUGH_PRICE) {
          return {
            ...result,
            render: (text, item) => (
              <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                {formatTextFloat(formatPrice(text), 2, true)}
              </TextBlink>
            ),
          };
        }

        if (key === Const.index.COM_GROUP_CODE) {
          return {
            ...result,
            isString: true,
            valueFromItem: item =>
              formatComGroupCode(
                getDataFollowKeyByDot(item, Const.index.COM_GROUP_CODE),
              ),
            thStyle: { textAlign: 'left' },
            tdClassName: 'text-left',
            render: (text, item) => (
              <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
                {formatComGroupCode(text)}
              </TextBlink>
            ),
          };
        }

        return {
          ...result,
          render: (text, item) => (
            <TextBlink item={item} tradingDate={Const.index.TRADING_DATE}>
              {formatTextFloat(text)}
            </TextBlink>
          ),
        };
      },
    );
  };

  handleRowReorder = ids => {
    const { setSortedIds } = this.props;
    setSortedIds(ids);
  };

  onRowClick = organCode => {
    const { listOrganizationByOrganCode, syncType } = this.props;
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listOrganizationByOrganCode[organCode],
    });
  };

  render() {
    const {
      ids,
      listHideColumnIndex,
      isFetching,
      idHover,
      changeIdHover,
      sortState,
      changeTableIndexSortState,
    } = this.props;

    return (
      <div className="watchlist-summary-wrap d-flex flex-fill px-20">
        <Table
          clickRow={this.onRowClick}
          onRowReorder={this.handleRowReorder}
          sortState={sortState}
          onSort={changeTableIndexSortState}
          ids={ids}
          isLoading={isFetching}
          resizable={true}
          columnDraggable={true}
          rowDraggable={true}
          hideColumns={listHideColumnIndex}
          getDataFromRedux={getDataFromRedux}
          schema={this.getSchema()}
          onResize={() => {
            this.props.dispatch(notifyResizeColumnTable());
          }}
          idHover={idHover}
          changeIdHover={changeIdHover}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => ({
  isFetching: state[REDUCER_NAME].isFetching,
  ids:
    state[REDUCER_NAME].sortedIds || state[REDUCER_NAME].listTickerSummaryTable,
  listHideColumnIndex: state[REDUCER_NAME].listHideColumnIndex,
  idHover: state[REDUCER_NAME].organCodeHover,
  sortState: state[REDUCER_NAME].tableIndexSortState,
  summaryBidAskRealtimeData: state[REDUCER_NAME].summaryBidAskRealtimeData,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  syncType: syncComponentSelector(state, componentName, componentId),
});

const mapDispatchToProps = {
  toggleConfirmPopupDelete,
  changeIdHover,
  changeTableIndexSortState,
  setSortedIds,
  updateBidAsk,
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TableIndex);
